const serialize = function(obj) {
  var str = [];
  for (var p in obj)
    if (obj.hasOwnProperty(p)) {
      str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
    }
  return str.join("&");
};

const websocket_proxy = function(
  path = "",
  mode = "get",
  query = null,
  post = null,
  ondata = null
) {
  if ((post && post.websocket) || (query && query.websocket)) {
    let promise = new Promise((resolve, reject) => {
      let $socket = null;
      if (post && post.websocket) {
        $socket = post.websocket;
        delete post.websocket;
      }
      if (query && query.websocket) {
        $socket = query.websocket;
        delete query.websocket;
      }

      let reqID = new Date().getTime();

      let packreq = {
        method: mode,
        path: path,
        req: {
          headers: [],
          body: post,
          query: query
        },
        reqID
      };

      if (global.config.socketiodebug)
        console.log("WEBSOCKET-DEBUG", "REQ", reqID, packreq);

      $socket.client.emit("proxy-request", packreq);

      let timeoutSession = setTimeout(() => {
        clearTimeout(timeoutSession);
        timeoutSession = null;
        let pack = { status: 408, data: { error: "Timeout" } };
        if (global.config.socketiodebug)
          console.log("WEBSOCKET-DEBUG", "RES", reqID, pack);
        reject(pack);
      }, global.config.socketiotimeout || 10000);

      $socket.client.on(`proxy-request-${reqID}`, result => {
        if (timeoutSession == null) return;

        if (global.config.socketiodebug)
          console.log("WEBSOCKET-DEBUG", "RES", reqID, result);

        if (result.status == 200) resolve(result);
        else reject(result);
        $socket.client.off(`proxy-request-${reqID}`);

        clearTimeout(timeoutSession);
        timeoutSession = null;
      });
    });
    return promise;
  }
  return null;
};

export default websocket_proxy;
